import Admin from "@system/config/admin";
import Api from "../APIHandler";
import Helper from "src/helper/Helper";

const API = new Api({});

class AdminCommonAPICall {

    getRoleList = async (params = {}) => {
        let res = [];
        let param = {};
        param.params = params
        try {
        await API.get(Admin.GET_ROLE_LIST, param).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = resHer.data.data
            }
        });
    } catch (e) {
        res = e?.response?.data
    }
        return res;
    };

    getOrgList = async (params = {}) => {
        let res = {};
        let param = {};
        param.data = { ...params }
        try {
        await API.get(Admin.GET_ORG_LIST, params).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = resHer.data.data
            }
        });
    } catch (e) {
        res = e?.response?.data
    }
        return res;
    };

    fetchBomManagementList = async (params) => {
        let res = {};
        const param = {}
        param.params = params
        await API.get(Admin.GET_BOM_VIEWER, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data.data
            }
        }).catch((e) => {
            res = e?.response?.data
        });

        return res;
    };

    fetchBomDetailsManagementList = async (params) => {
        let res = {};
        const param = {}
        param.params = params
        try {
        await API.get(Admin.GET_BOM_VIEWER_DETAILS, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer?.data?.data
            }
        });
    } catch (e) {
        res = e?.response?.data
    }
        return res;
    };

    fetchComplianceManagementList = async (params) => {
        let res = {};
        const param = {}
        param.data = params
        let url = Admin.GET_COMPLIANCE_LIST;
        await API.post(url, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data?.data?.eccnData
            }
        }).catch(err => {
            res = err?.response?.data
        });
        return res;
    }

    exportComplianceManagementSurvey = async (params) => {
        let res = {};
        let param = {}
        const formData = new FormData()
        formData.append("orderNumber", params)
        param.data = formData
        param.data.isMultipart = true;
        param.data.responseType = "blob"

        await API.post(Admin.EXPORT_COMPLIANCE_SURVEY, param).then((resHer) => {
            
            if (resHer?.data) {
                Helper.downloadFileFromRes(resHer?.data, 'ECCN_SurveyResponse.pdf');
              }
        })
        return res;
    }

}

export default AdminCommonAPICall;